module.exports = __webpack_public_path__ + "static/media/termelouzem_iroda_kialakitas_2.a06f8757.jpg";